// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"db66976a","58":"d2b3b3a6","156":"09db84fb","194":"52b5ce53","372":"6c4fc616","480":"62308e55","493":"c7a364b8","602":"481d1e28","818":"b71c26d1"}[chunkId] + ".chunk.js";
};